module.exports = __webpack_public_path__ + "img/doboztervezes-thumb.c503fd39.jpg";